import isMobile from 'common/utils/isMobile';
import tooltip from 'common/utils/tooltip';
import { LOANS } from 'loans.module/common/domain/constants.loans.js';

class LoansSignUpFormFieldsController {

  constructor($translate, $state) {
    'ngInject';
    this.translate = $translate;
    this.tooltip = tooltip;
    this.state = $state;
    this.isMobile = isMobile();
  }

  $onInit() {
    this._initTranslations(this._initDeadLineView);
    this._assignInitialValues();
    this.tooltipTitle();
  }

  _initTranslations(callback) {
    const _this = this;
    this.translate('GLOBALS.MONTHS').then(translation => {
      this._monthsString = translation;
      callback.apply(_this);
    });
  }

  _initDeadLineView() {
    this.deadlineView = this.getDeadlineView();
  }

  _assignInitialValues() {
    const { amount, wantInsurance, monthlyAmount, annualTerm } = this.backSimulation;
    const { salePrice, acquisitionCost, diff } = this.simulation.amountSimulation;
    this.amount = amount;
    this.wantInsurance = wantInsurance;
    this.monthlyAmount = monthlyAmount;
    this.salePrice = salePrice;
    this.acquisitionCost = acquisitionCost;
    this.diff = diff;
    this.annualTerm = annualTerm;
  }

  getDeadlineView() {
    return `${this.backSimulation.deadline} ${this._monthsString}`;
  }

  isHousingLoan() {
    return this.housingLoan === true;
  }

  isHousingChange() {
    return this.isHousingLoan() && this.housingChange;
  }

  showFullInterestRateLabel() {
    return this.housingLoan || this.isVariousCredit;
  }

  isMandatoryInsurance() {
    return this.loan.signUp.mandatoryInsurance;
  }
  isSocialAgreementHousingLoan() {
    return this.loan && this.loan.id === LOANS.ID.AGREEMENT_HOUSING_LOAN;
  }

  tooltipTitle() {
    let title = null;
    
    if (this.isSocialAgreementHousingLoan()) {
      title = '{{ "LOANS.SIGN_UP.TOOLTIPS.SOCIAL_HOUSING_AGREEMENT.DETAILED_INSURANCE_INFO2" | translate }}';
    } else {
      title = '{{ "LOANS.SIGN_UP.TOOLTIPS.INSURANCE_INFO" | translate }}';
    }

    return title;
  }
}

export default LoansSignUpFormFieldsController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpForm/loansSignUpFormFields/loansSignUpFormFields.controller.js